import { render, staticRenderFns } from "./shortList.vue?vue&type=template&id=432b22ee&scoped=true"
import script from "./shortList.vue?vue&type=script&lang=js"
export * from "./shortList.vue?vue&type=script&lang=js"
import style0 from "./shortList.vue?vue&type=style&index=0&id=432b22ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432b22ee",
  null
  
)

export default component.exports